export default {
      id: "obd__fuel_level-usage",
      viewBox: "0 0 22 15",
      url: __webpack_public_path__ + "img/icons.svg#obd__fuel_level",
      toString: function () {
        return this.url;
      }
    }